import RoutesMap from '../../route_control/RouteControl'
import { LuKeyRound, LuPower, LuUserCircle, LuUserCog, LuLanguages } from 'react-icons/lu'
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import Logo from '../../assets/images/rexomovers.png'
import moment from 'moment/moment'
import { SessionManager } from '../../utils'
import { useTranslation } from 'react-i18next'

export const HeaderImport = {
    RoutesMap,
    LuKeyRound,
    LuPower,
    LuUserCircle,
    LuUserCog,
    LuLanguages,
    useNavigate,
    Dropdown,
    Logo,
    moment,
    SessionManager,
    useTranslation,
}